import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, message, Checkbox, Card, Modal } from "antd";
import axios from "axios";
import { useSelector } from "react-redux";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { BsTruck } from "react-icons/bs";
import { BsBox } from "react-icons/bs";
import { GrCheckboxSelected } from "react-icons/gr";
import { AiOutlineSearch } from "react-icons/ai";
import { FaFilter } from "react-icons/fa";
import { API, Headers } from "../../Config";
import PageHeader from "../../Routes/PageHeader";
import "./style.css";
import LoadingBox from "../../Components/LoadingBox";
import { Select, DatePicker, Input } from "antd";
import moment from "moment";
import UnAssignedModal from "./component/UnAssignTripModal";

function AssignBoxesToTrip() {
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [data, setData] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const [boxes2, setBoxes2] = useState([]);
  const [hover, setHover] = useState(false);
  const [filter, setFilter] = useState(false);
  const [tobeassigned, setToBeAssigned] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState("");
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [assignedModalShow, setUnAssignedModalShow] = useState(false);
  const [service, setServices] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const { Option } = Select;
  const Auth = useSelector((state) => state.Auth.user);
  const { RangePicker } = DatePicker;

  useEffect(() => {
    loaddata();

    loadServiceType();
    listUnAssigned();
  }, []);

  const loadServiceType = () => {
    axios

      .get(API.BASR_URL + API.SERVICE_TYPE_LIST + `/list`, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setServices(data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const onSelect = (value) => {
    setLoading2(true);
    let arr = boxes2;
    const newArr = arr.filter((data) => data?.service?.name === value);
    setBoxes(newArr);
    setTimeout(() => {
      setLoading2(false);
    }, 500);
  };

  const onChooseDate = (date) => {
    let fromDate = moment(date[0]).toISOString();
    let toDate = moment(date[1]).toISOString();

    setLoading2(true);
    axios
      .get(
        API.BASR_URL + API.BOXES_LIST + `/listUnAssigned/${toDate}/${fromDate}`,
        {
          headers: Headers(),
        }
      )
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setBoxes(data);
          console.log(response);
          setLoading2(false);
        }
      })
      .catch(function (error) {
        console.log(error);
        message.error("Something went wrong ........");
        setLoading(false);
      });
  };

  const loaddata = () => {
    setLoading(true);
    axios
      .get(API.BASR_URL + API.TRIP_LIST + `/list`, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          // console.log(data);
          setData(data);
        } else {
          message.error("Oops.Something went wrong");
        }
        setLoading(false);
        setIndicator(false);
      })
      .catch(function (error) {
        message.error("Oops.Something went wrong");
        setIndicator(false);
        setLoading(false);
      });
  };

  const reload = () => {
    loaddata();
    setToBeAssigned([]);
  };

  const handleConfirm = () => {
    setIsModalVisible(false);
    onFinish();
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setIsVisible(true);
  };

  const listUnAssigned = () => {
    setLoading2(true);
    axios
      .get(API.BASR_URL + API.BOXES_LIST + "/UnAssigned", {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setBoxes(data);
          setBoxes2(data);
          setLoading2(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const selectTrip = (id) => {
    setSelectedTrip(id);
  };

  const selectBoxes = (boxes) => {
    let boxIds = [];
    boxes.map((item, index) => {
      console.log(item[0].box_number);
      let id = item[0].box_number;
      boxIds.push(id);
    });
    setSelectedBoxes(boxIds);
  };

  const onSearchBox = (val) => {
    setLoading2(true);
    axios
      .get(API.BASR_URL + API.BOXES_VIA_SEARCH + val, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          if (data.length <= 0) {
            message.error(`Boxss ${val} Not Found`);
          }
          setBoxes(data);
          setLoading2(false);
        }
      })
      .catch(function (error) {
        message.error(`Boxss ${val} Not Found`);
        console.log(error);
        setLoading2(false);
      });
  };

  const onChooseServiceType = (value) => {
    setLoading2(true);
    let arr = boxes2;
    const newArr = arr.filter((data) => data?.service?.name === value);
    setBoxes(newArr);
    setTimeout(() => {
      setLoading2(false);
    }, 500);
  };

  const onFinish = () => {
    let requestObj = {
      tripId: selectedTrip,
      boxIds: selectedBoxes,
      updated_user: Number(Auth.id),
      status: 6,
      created_from: "web",
      is_show: isVisible,
    };

    axios({
      method: "post",
      url: API.BASR_URL + API.BOXES_LIST + `/assignBoxesToTrip`,
      headers: Headers(),
      data: requestObj,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          reload();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  const Column = ({ children, className, title, length }) => {
    const [, drop] = useDrop({
      accept: "box",
      drop: () => ({ name: title }),
    });
    return (
      <div ref={drop} className={`${className} AssignBox-box8 `}>
        {`${title} (${length})`}
        {children}
      </div>
    );
  };

  const MovableItem = (item) => {
    var arr = tobeassigned;
    const [{ isDragging }, drag] = useDrag({
      item: {
        index: item.item.box_number,
      },
      type: "box",
      end: (item, monitor) => {
        const dropResult = monitor.getDropResult();

        if (dropResult && dropResult.name === "Assigned") {
          // console.log("dropResult ===>", dropResult);
          let box = boxes.filter((i) => i.box_number === item.index);
          arr.push(box);

          let checkIndex = boxes.findIndex((i) => i.box_number === item.index);
          // console.log(checkIndex);
          if (checkIndex >= 0) {
            boxes.splice(checkIndex, 1);
          }
          forceUpdate();
        } else {
          //   setIsFirstColumn(false);
        }
        setToBeAssigned(arr);
        selectBoxes(tobeassigned);
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    const opacity = isDragging ? 0.4 : 1;

    return (
      <div className="movable-item" ref={drag} style={{ opacity }}>
        <div className="AssignBox-box2">
          <div className="AssignBox-box3">
            <BsBox color="#9c27b0" size={40} />
          </div>
          <div className="AssignBox-box4"></div>
          <div className="AssignBox-box5">
            <div className="AssignBox-box6">
              <div className="AssignBox-txt2">BOX No :</div>
              <div className="AssignBox-txt3">
                {item.columnName === "UnAssigned"
                  ? item.item.box_number && item.item.box_number
                  : item.item[0]?.box_number && item.item[0]?.box_number}
              </div>
            </div>
            <div className="AssignBox-box6">
              <div className="AssignBox-txt2">Service :</div>
              {/* <div className="AssignBox-txt3">
                {item.columnName === "UnAssigned"
                  ? item.item.service && item.item.service.name
                  : item.item[0]?.service.name && item.item[0]?.service.name}
              </div> */}
              <div className="AssignBox-txt3">
                {item.columnName === "UnAssigned"
                  ? item.item.service?.name
                  : item.item[0]?.service?.name}
              </div>
            </div>
            <div className="AssignBox-box6">
              <div className="AssignBox-txt2">Weight :</div>
              <div className="AssignBox-txt3">
                {item.columnName === "UnAssigned"
                  ? item.item.weight
                  : item.item[0]?.weight && item.item[0]?.weight}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const returnItemsForColumn = (columnName) => {
    var arr = columnName === "UnAssigned" ? boxes : tobeassigned;
    return arr.map((item, index) => (
      <MovableItem
        key={item.box_number}
        item={item}
        // setItems={items}
        columnName={columnName}
      />
    ));
  };

  const showConfirmModal = () => {
    setIsModalVisible(true);
  };
  return (
    <div>
      <PageHeader
        PageName={"Assign Boxes To Trip"}
        breadScrum={"Admin /Assign Boxes To Trip"}
        loader={indicator}
        RightButton={"Assign"}
        RightClcik={showConfirmModal}
      />

      {loading ? (
        <LoadingBox />
      ) : (
        <Container fluid>
          <DndProvider backend={HTML5Backend}>
            <Card style={{ borderRadius: 10 }}>
              <div className="AssignBox-box9">
                <Button
                  style={{
                    borderRadius: 4,
                    fontSize: 12,
                  }}
                  onClick={() => {
                    setUnAssignedModalShow(true);
                  }}
                >
                  Remove From Trip
                </Button>
                &nbsp; &nbsp;
                {filter ? (
                  <div className="AssignBox-box10">
                    <RangePicker
                      style={{ borderRadius: 6, marginRight: 10 }}
                      onChange={onChooseDate}
                    />
                    <Select
                      showSearch
                      className="borderedSelect"
                      bordered={false}
                      placeholder="Select Service Type"
                      optionFilterProp="children"
                      onChange={onChooseServiceType}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{ borderRadius: 6, marginRight: 10 }}
                    >
                      {service.map((option) => (
                        <Option key={option.id} value={option.name}>
                          {option.name}
                        </Option>
                      ))}
                    </Select>
                    <div style={{ margin: 5 }} />
                  </div>
                ) : null}
                <div className="AssignBox-box10">
                  <Input
                    placeholder="Search Box"
                    onPressEnter={(val) => onSearchBox(val.target.value)}
                    prefix={<AiOutlineSearch color="#999" />}
                    style={{ borderRadius: 6 }}
                  />
                  <div style={{ margin: 5 }} />
                  <div
                    className="AssignBox-box11"
                    onClick={() => setFilter(!filter)}
                  >
                    <FaFilter />
                  </div>
                </div>
              </div>
              <br />
              <Row>
                <Col sm="4" xs="4">
                  <div className="AssignBox-box1">
                    <div className="AssignBox-txt4">Trips</div>
                    {data
                      .sort((a, b) => b.id - a.id)
                      .map((item, index) => {
                        return (
                          <div key={index}>
                            <div className="AssignBox-box2">
                              <div className="AssignBox-box3">
                                <BsTruck color="#1e88e5" size={40} />
                              </div>
                              <div className="AssignBox-box4"></div>
                              <div className="AssignBox-box7">
                                <div className="AssignBox-box5">
                                  <div className="AssignBox-txt1">
                                    <div className="AssignBox-txt2">
                                      TRIP No: {item.id}
                                    </div>
                                  </div>
                                  <div className="AssignBox-txt1">
                                    TRUCK No: {item.truck_no}
                                  </div>
                                  <div className="AssignBox-txt5">
                                    {item.to_branch && item.to_branch.name}
                                  </div>
                                </div>
                                <div>
                                  <Checkbox
                                    onClick={() => selectTrip(item.id)}
                                    value={item.id}
                                    checked={item.id === selectedTrip}
                                  ></Checkbox>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    ;
                  </div>
                </Col>
                <Col sm="4" xs="4">
                  <Column
                    title="Assigned"
                    className="column first-column"
                    length={tobeassigned.length}
                  >
                    {returnItemsForColumn("Assigned")}
                  </Column>
                </Col>
                <Col sm="4" xs="4">
                  {loading2 ? (
                    <LoadingBox />
                  ) : (
                    <Column
                      title="UnAssigned"
                      className="column second-column"
                      length={boxes.length}
                    >
                      {returnItemsForColumn("UnAssigned")}
                    </Column>
                  )}
                </Col>
              </Row>
            </Card>
          </DndProvider>
          {assignedModalShow ? (
            <UnAssignedModal
              visible={assignedModalShow}
              onClose={() => setUnAssignedModalShow(false)}
            />
          ) : null}
          <Modal
            title="Confirm Box Assignment"
            visible={isModalVisible}
            onOk={handleConfirm}
            onCancel={handleCancel}
            okText="Confirm"
            cancelText="Cancel"
          >
            <Checkbox
              checked={isVisible}
              onChange={(e) => setIsVisible(e.target.checked)}
            >
              Visible
            </Checkbox>
          </Modal>
        </Container>
      )}
    </div>
  );
}

export default AssignBoxesToTrip;
